export const SITE = {
  name: "infocure technologies",
  phone: "+91 91361 80148",
  phoneHref: "tel:+919136180148",
  email: "solutions@infocure.in",
  whatsapp: "https://wa.me/+919136180148",
  domain: "https://infocure.in",
};

// FINAL LOCKED IA — flagship business services only
export const NAV_SERVICES = [
  { name: "Digital Transformation", href: "/services/digital-transformation" },
  { name: "SAP Consulting", href: "/services/sap-consulting" },
  { name: "Oracle Consulting", href: "/services/oracle-consulting" },
  { name: "Salesforce Consulting", href: "/services/salesforce-consulting" },
  { name: "Build & Cloud", href: "/services/build-cloud" },
];

export const NAV_INSIGHTS = [
  { name: "Articles", href: "/insights" },
  { name: "Case Studies", href: "/case-studies" },
  { name: "Resources", href: "/insights/resources" },
];

export const NAV_PRODUCTS = [
  { name: "CRM", href: "/products/crm" },
  { name: "Custom ERP", href: "/products/erp" },
  { name: "HRMS", href: "/products/hrms" },
  { name: "Dealer Management (DMS)", href: "/products/dms" },
  { name: "Order Management (OMS)", href: "/products/oms" },
  { name: "Production Planning (PPC)", href: "/products/ppc" },
  { name: "EXIM Trade Management", href: "/products/exim" },
  { name: "Vehicle Tracking", href: "/products/vehicle-tracking" },
  { name: "e-Invoicing", href: "/products/e-invoicing" },
];

export const NAV_INDUSTRIES = [
  { name: "Manufacturing", href: "/industries/manufacturing" },
  { name: "Automotive", href: "/industries/automotive" },
  { name: "Engineering", href: "/industries/engineering" },
  { name: "Pharmaceutical", href: "/industries/pharmaceutical" },
  { name: "Textile & Apparel", href: "/industries/textile-apparel" },
  { name: "Healthcare & Life Sciences", href: "/industries/healthcare" },
  { name: "Trading & Distribution", href: "/industries/trading-distribution" },
  { name: "FMCG & Distribution", href: "/industries/fmcg-distribution" },
  { name: "Logistics & Supply Chain", href: "/industries/logistics" },
];

export const NAV_ABOUT = [
  { name: "Company", href: "/about" },
  { name: "Leadership", href: "/about#leadership" },
  { name: "Careers", href: "/about#careers" },
];

export const REGIONS = [
  { code: "IN", label: "India" },
  { code: "AE", label: "UAE & GCC" },
  { code: "EU", label: "Europe" },
  { code: "GLOBAL", label: "Global" },
];
